import React, { useEffect, useState } from 'react';

import useGlobalState from '../../GlobalStateContext';
import ActionButton from '../../elements/ActionButton';
import useNumberParams from '../../hooks/useNumberParams';
import { ROLES } from '../../services/AdminPolicyService';
import AdminsList from '../admin/AdminsList';
import ResellersList from '../reseller/ResellersList';

import SuperAgentDetails from './SuperAgentDetails';
import SuperAgentMetrics from './SuperAgentMetrics';

import CRMApi from 'Api/CRM/CRMApi';

export default function SuperAgentShow() {
    const { id } = useNumberParams();
    const [superAgent, setSuperAgent] = useState({});
    const { loggedAdmin } = useGlobalState();

    useEffect(() => {
        CRMApi.get(`super_agent/${id}?transformStateAndCountryFields`).then((response) => setSuperAgent(response.data));
    }, []);

    return (
        <>
            <SuperAgentMetrics url={`/crea/api/metrics/${id}`} />
            <SuperAgentDetails superAgent={superAgent} />
            <ResellersList source="super_agent" relatedId={id} />
            <ActionButton
                url={`/super_agent/${id}/attach/admin`}
                title="Attach Master Agent"
                roles={ROLES.MAIN_ADMINS}
            />
            {loggedAdmin.hasMainRole() && <AdminsList source="super_agent" relatedId={id} cardTitle="Master Agents" />}
        </>
    );
}
